<ng-container *ifScreenSize="screenType.Mobile">
  <div class="barcode-card" [ngClass]="{ 'hide-footer': !showFooter, 'wallet-card': isWallet }" *ngIf="barcode$ | async as barcode">
    <ng-container *ngIf="card$ | async as card">
      <div class="upper-barcode-container d-flex flex-row align-items-center justify-content-between" *ngIf="!isWallet">
        <!--Name and ID-->
        <div class="d-flex flex-column gap-1">
          <h4
            class="member-name font-size-16 fw-bold text-uppercase mb-0 text-white"
            *ngIf="memberDetails$ | async as memberDetails"
          >
            {{ memberDetails.FirstName }} {{ memberDetails.Surname?.charAt(0) }}.
          </h4>
          <div class="d-flex flex-row align-items-center font-size-12 text-white">
            <span *ngIf="(card.ProductCode | productCode | translate) === 'Season Ticket Member'"
              >{{ 'member.card.membership.label' | translate }}
            </span>
            <span *ngIf="(card.ProductCode | productCode | translate) !== 'Season Ticket Member'"
              >{{ 'member.card.membership.buyer.label' | translate }}
            </span>
            <span class="ps-1">{{ card.ExternalRefNumber }}</span>
          </div>
        </div>

        <a class="wallet-button d-flex flex-row align-items-center" routerLink="/rewards/wallet">
          <span class="material-symbols-outlined text-white"> qr_code_scanner </span>
          <span class="font-size-14 text-white">{{ 'nav.wallet.btn' | translate }}</span>
        </a>
      </div>

      <ng-container *ngIf="!(loading$ | async)"
        ><div *ngIf="showBarcode">
          <div class="card-qr-code bg-primary d-flex flex-column align-items-center justify-content-center">
            <div class="qr">
              <qrcode [qrdata]="barcode.Barcode" [width]="127" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
            </div>
            <p class="font-size-12 text-white m-0">
              {{ 'wallet.barcode.scan' | translate }}
            </p>
          </div>
        </div></ng-container
      >

      <!--Balances-->
      <div class="points-balance-container d-flex flex-row align-items-center">
        <div class="balance d-flex flex-row align-items-center">
          <span class="icons material-icons text-white" aria-hidden="true">loyalty</span>

          <div class="points-container d-flex flex-column justify-content-center">
            <span class="fw-bold text-white font-heading font-size-18">{{ pointsBalance$ | async | number: '1.0-0' }}</span>
            <span class="font-size-12 text-white text-capitalize">{{ 'barcode.your.points' | translate }}</span>
          </div>
        </div>

        <div class="balance d-flex flex-row align-items-center">
          <span class="icons material-symbols-outlined text-white"> money_bag </span>

          <div class="points-container d-flex flex-column justify-content-center">
            <span class="fw-bold text-white font-heading font-size-18">{{ combinedCard$ | async | FortressCurrencyPipe }}</span>
            <span class="font-size-12 text-white text-capitalize">{{ 'barcode.credits' | translate }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <fgb-ecash-button [isMemberCard]="false"></fgb-ecash-button>

    <!-- mobile navigation -->
    <ng-container *ngIf="isHomePage">
      <div class="mobile-navigation-wrapper" [class.at-end]="atRightEnd">
        <div #nav class="mobile-navigation d-flex flex-row pb-2" (scroll)="onNavScroll()">
          <div class="navigation" routerLink="/rewards">
            <span class="icons material-symbols-outlined"> redeem</span>
            <a class="text-white font-size-14">{{ 'nav.rewards' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/challenges">
            <span class="icons material-icons"> emoji_events </span>
            <a class="text-white font-size-14">{{ 'nav.challenges' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/games">
            <span class="icons material-icons"> sports_esports </span>
            <a class="text-white font-size-14">{{ 'nav.games' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/loadedtickets">
            <span class="icons material-icons"> book_online </span>
            <a class="text-white font-size-14">{{ 'nav.loaded.tickets' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/earn">
            <span class="icons material-icons"> money </span>
            <a class="text-white font-size-14">{{ 'nav.earn' | translate }}</a>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isWallet && (card$ | async) as card">
      <ng-container *ngIf="card.DiscountLevel && card.DiscountLevel !== '0'">
        <div class="discount-container d-flex w-100 align-items-center justify-content-between">
          <span class="font-size-14 text-white">{{ 'wallet.discount.label' | translate }}</span>
          <span class="font-size-14 text-white fw-bold">{{ card.DiscountLevel }}%</span>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
